/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import history from '../../util/history'
import CheckInFormStore from '../../store/check_in/CheckInFormStore'
import PrefectureOptionsStore from '../../store/options/PrefectureOptionsStore'
import SelfCheckInView from '../../view/pages/check_in/SelfCheckInView'
import checkinAction from '../../action/check_in/index'

class SelfCheckInContainer extends Component {
  static getStores() {
    return [CheckInFormStore, PrefectureOptionsStore]
  }

  static calculateState(prevState, props) {
    return {
      checkin: CheckInFormStore.getState(),
      prefectures: PrefectureOptionsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    // Disable History Back
    const path = window.location.pathname
    window.addEventListener(
      'popstate',
      e => {
        e.stopPropagation()
        history.push(path)
        return false
      },
      false
    )

    const reservationId = Object.prototype.hasOwnProperty.call(this.props.match.params, 'reservationId') ? this.props.match.params.reservationId : null
    const token = Object.prototype.hasOwnProperty.call(this.props.match.params, 'token') ? this.props.match.params.token : null
    if (reservationId && token) {
      checkinAction.fetchOne(reservationId, token)
    }
  }

  render() {
    return SelfCheckInView(this.state)
  }
}

export default withRouter(Container.create(SelfCheckInContainer, { withProps: true }))
